import type { ComponentProps, ReactNode } from "react"
import { type VariantProps } from "class-variance-authority"
import { TabsTrigger as TabsTriggerBase } from "@/v2-ui/tabs/base/TabsBase"
import Badge from "@/v2-ui/badge"
import { tabsTriggerVariants } from "./tabs.constants"

export type TabsTriggerProps = ComponentProps<typeof TabsTriggerBase> &
  VariantProps<typeof tabsTriggerVariants> & {
    renderAfter?: ReactNode
  }

function TabsTrigger(props: TabsTriggerProps) {
  const { className, size, children, renderAfter, ...tabsTriggerBaseProps } =
    props
  return (
    <TabsTriggerBase
      className={tabsTriggerVariants({ className, size })}
      {...tabsTriggerBaseProps}
    >
      {children}
      {typeof renderAfter === "string" ? (
        <Badge size="xs" variant="outline">
          {renderAfter}
        </Badge>
      ) : (
        renderAfter
      )}
    </TabsTriggerBase>
  )
}

export default TabsTrigger
